/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ answered: NonNullable<unknown>, total: NonNullable<unknown> }} Components_Ask_Questions_Label_Answered_CountInputs */

const es_components_ask_questions_label_answered_count = /** @type {(inputs: Components_Ask_Questions_Label_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered}/${i?.total} respondidas`)
};

const en_components_ask_questions_label_answered_count = /** @type {(inputs: Components_Ask_Questions_Label_Answered_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered}/${i?.total} answered`)
};

/**
* | output |
* | --- |
* | "{answered}/{total} answered" |
*
* @param {Components_Ask_Questions_Label_Answered_CountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_answered_count = /** @type {((inputs: Components_Ask_Questions_Label_Answered_CountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_Answered_CountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_answered_count(inputs)
	return en_components_ask_questions_label_answered_count(inputs)
});
export { components_ask_questions_label_answered_count as "components.ask_questions.label.answered_count" }